import { render, staticRenderFns } from "./ShortcutsMenu.vue?vue&type=template&id=f3f4ec64&scoped=true"
import script from "./ShortcutsMenu.vue?vue&type=script&lang=js"
export * from "./ShortcutsMenu.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsMenu.vue?vue&type=style&index=0&id=f3f4ec64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f4ec64",
  null
  
)

export default component.exports